// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"619":"3007342f","787":"97a2eb4f"}[chunkId] + ".chunk.js";
};